import { stats } from "@/mocks/homeData";
import { Link } from "react-router-dom";

const partners = [
  { name: "Microsoft", icon: "ri-windows-line" },
  { name: "AWS", icon: "ri-cloud-line" },
  { name: "Google Cloud", icon: "ri-google-line" },
  { name: "i3Cert", icon: "ri-award-line" },
];

export default function AboutSection() {
  return (
    <section className="py-24 bg-slate-50" id="about">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative pb-6 md:pb-0">
            <div className="relative rounded-xl overflow-hidden w-full h-[300px] sm:h-[400px] md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20professional%20AI%20technology%20team%20collaborating%20in%20modern%20office%20Chicago%20global%20consulting%20firm%20working%20together%20on%20AI%20systems%20bright%20open%20workspace%20natural%20light%20warm%20neutral%20tones%20authentic%20atmosphere%20wide&width=720&height=500&seq=aiabout2026&orientation=landscape"
                alt="CPI Technologies AI team collaboration"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>

            {/* Floating Card - Global */}
            <div className="hidden sm:block absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-xl p-5 w-56 border border-slate-100">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#C8F135]">
                  <i className="ri-map-pin-2-line text-black text-lg" />
                </div>
                <div>
                  <div className="text-xs text-slate-500">Global Offices</div>
                  <div className="text-sm font-bold text-slate-900">Chicago &amp; Lagos</div>
                </div>
              </div>
              <div className="text-xs text-slate-400">Americas &amp; Africa delivery</div>
            </div>

            {/* Founded Badge */}
            <div className="hidden sm:block absolute -top-4 -left-4 md:-left-6 bg-black rounded-xl p-4 text-white text-center">
              <div className="text-3xl font-black text-[#C8F135]">1996</div>
              <div className="text-xs font-medium text-slate-300">Founded<br />Lagos, Nigeria</div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#C8F135]/20 border border-[#C8F135]/40 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-[#C8F135]" />
              <span className="text-[#6a7a00] text-xs font-semibold uppercase tracking-wider">AI-First, Global, Trusted</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight mb-6">
              Our Legacy is Technology.
              <br />
              <span style={{color: "#9bc400"}}>Our Future is AI.</span>
            </h2>

            <p className="text-slate-600 text-base leading-relaxed mb-5">
              CPI Technologies Inc was founded in 1996 in Lagos, Nigeria, and today operates as a global AI and technology consulting firm headquartered in Chicago, USA, with a strong presence across Africa and North America.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-5">
              We partner with Fortune 500 companies, government institutions, and high-growth businesses to adopt AI responsibly, build intelligent systems, and create measurable business advantage.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              We combine deep enterprise IT experience in cloud, cybersecurity, and software with specialized AI expertise to deliver solutions that are ethical, scalable, and business-aligned.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-8 py-6 border-t border-b border-slate-100">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-3xl font-black text-slate-900">{s.value}</div>
                  <div className="text-xs text-slate-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            {/* Global Partners */}
            <div className="mb-8">
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Global Partners</p>
              <div className="flex flex-wrap gap-3">
                {partners.map((p) => (
                  <div key={p.name} className="flex items-center gap-2 bg-white border border-slate-100 rounded-lg px-4 py-2">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${p.icon} text-slate-600 text-sm`} />
                    </div>
                    <span className="text-sm font-semibold text-slate-700">{p.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg bg-black text-[#C8F135] font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-zinc-800 transition-colors"
              >
                Our Story <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg border border-slate-200 text-slate-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:border-slate-400 transition-colors"
              >
                Book a Free AI Consultation
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
